<template>
  <ml-dialog
    ref="dialogRef"
    title="工单详情"
    width="900px"
    :showSubmitBtn="false"
    @click-close="handleCancel"
  >
    <template #body>
      <div class="detail-dialog-content">
        <!-- 工单基本信息 -->
        <el-form label-width="120px" style="margin-bottom: 20px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="工单标题:">
                <span>{{ detailData.title }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属项目名称:">
                <span>{{ detailData.projectName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属阿米巴:">
                <span>{{ detailData.companyName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="参与人员:">
                <span>{{ detailData.dealUserName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="故障类型:">
                <span>{{ detailData.errorTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="完工工时:">
                <span>{{ detailData.hours }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="故障结果:">
                <span>{{ detailData.dealResult }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工单状态:">
                <el-tag
                  :type="getStatusTagType(detailData.apprStatus)"
                  v-if="getStatusText(detailData.apprStatus)"
                  size="small"
                >
                  {{ getStatusText(detailData.apprStatus) }}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="故障描述:">
                <span>{{ detailData.errorDesc }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="detailData.status">
            <el-col :span="12">
              <el-form-item label="审核状态:">
                <el-tag
                  :type="getAuditStatusTagType(detailData.status)"
                  v-if="getAuditStatusText(detailData.status)"
                  size="small"
                >
                  {{ getAuditStatusText(detailData.status) }}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="现场处理图片:">
                <div
                  class="image-list"
                  v-if="detailData.attachVos && detailData.attachVos.length > 0"
                >
                  <div v-for="(img, index) in detailData.attachVos" :key="index" class="image-item">
                    <el-image
                      :src="`${baseUrl}${filePreviewUrl}/${img.filePath}`"
                      fit="cover"
                      class="image-thumbnail"
                      :preview-src-list="[`${baseUrl}${filePreviewUrl}/${img.filePath}`]"
                    >
                      <template #error>
                        <div class="image-error">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </template>
                    </el-image>
                  </div>
                </div>
                <div v-else class="no-image">暂无图片</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="detailData.apprDesc">
            <el-col :span="24">
              <el-form-item label="审核意见:">
                <span>{{ detailData.apprDesc }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
  </ml-dialog>
</template>

<script>
import { ref, watch, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import { BASEURL, FILEPREVIEWURL } from '@API'

export default {
  name: 'DetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    workOrderId: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const { dispatch } = useStore()
    // 弹窗引用
    const dialogRef = ref(null)
    const baseUrl = ref(BASEURL)
    const filePreviewUrl = ref(FILEPREVIEWURL)

    // 工单详情数据
    const detailData = ref({
      title: '',
      projectName: '',
      companyName: '',
      dealUserName: '',
      errorTypeName: '',
      hours: '',
      errorDesc: '',
      dealResult: '',
      status: '',
      apprStatus: '',
      apprDesc: '',
      attachVos: []
    })

    // 监听弹窗显示状态，加载数据
    watch(
      () => props.visible,
      async newVal => {
        if (newVal && dialogRef.value) {
          // 加载工单详情
          await loadWorkOrderDetail()
        }
      }
    )

    // 获取状态文本
    const getStatusText = status => {
      const statusMap = {
        '-1': '待处理',
        0: '无效',
        1: '有效'
      }
      return statusMap[status] || status
    }

    // 获取状态标签类型
    const getStatusTagType = status => {
      const typeMap = {
        '-1': 'warning',
        0: 'info',
        1: 'success'
      }
      return typeMap[status] || ''
    }

    // 获取审核状态文本
    const getAuditStatusText = auditStatus => {
      const statusMap = {
        0: '未审核',
        1: '已审核'
      }
      return statusMap[auditStatus] || auditStatus
    }

    // 获取审核状态标签类型
    const getAuditStatusTagType = auditStatus => {
      const typeMap = {
        0: 'warning',
        1: 'success'
      }
      return typeMap[auditStatus] || ''
    }

    // 加载工单详情
    const loadWorkOrderDetail = async () => {
      console.log('loadWorkOrderDetail', props.workOrderId)
      if (!props.workOrderId) return

      try {
        const { data } = await dispatch('fetchGetWorkOrderDetail', { errorId: props.workOrderId })
        console.log('detail data', data)
        detailData.value = data || {}
      } catch (error) {
        console.error('加载工单详情失败:', error)
      }
    }

    // 取消
    const handleCancel = () => {
      emit('close')
    }

    onMounted(async () => {
      await nextTick()
      if (props.workOrderId) {
        loadWorkOrderDetail()
      }
    })

    return {
      dialogRef,
      detailData,
      getStatusText,
      getStatusTagType,
      getAuditStatusText,
      getAuditStatusTagType,
      handleCancel,
      baseUrl,
      filePreviewUrl
    }
  }
}
</script>

<style scoped lang="scss">
.detail-dialog-content {
  padding: 10px;
  width: 100%;
  max-height: 500px;
  overflow-y: auto;

  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .image-item {
      width: 100px;
      height: 100px;
      cursor: pointer;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #e4e7ed;

      &:hover {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      }

      .image-thumbnail {
        width: 100%;
        height: 100%;

        :deep(.image-error) {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: #f5f7fa;
          color: #909399;
          font-size: 20px;
        }
      }
    }
  }

  .no-image {
    color: #909399;
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.detail-dialog-content {
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
